import React, {useState} from 'react'
import { useDispatch } from 'react-redux'
import { createAddress } from '../../redux/actions/addressAction'
import Modal from '../util/Modal'

const AddAddress = () => {

    const dispatch = useDispatch()
    const [name, setName] = useState("")
    const [address, setAddress] = useState("")
    const [state, setState] = useState("")
    const [country, setCountry] = useState("India")
    const [pinCode, setPinCode] = useState()
    const [phoneNumber, setPhoneNumber] = useState()
    const [error, setError] = useState("")
    const [loading, setLoading] = useState(false)

    const handleSubmit = () => {
        const data = {
            name: name,
            address: address,
            state: state,
            pinCode: pinCode,
            phoneNumber: phoneNumber,
            country: country
        }
        if (name.trim().length === 0 || address.trim().length === 0 || state.trim().length === 0 || country.trim().length === 0 || pinCode.trim().length === 0 || phoneNumber.trim().length === 0) {
            setError("Please Fill all the required fields")
        } else {
            setLoading(true)
            dispatch(createAddress(data))    
            .then(res=>{
                if (!res.success) {
                    setError(res.message)
                    setLoading(false)
                } else {
                    setLoading(false)
                    closeModal()
                }
            })
        }
    }

    const closeModal = () => {
        document.getElementById("closeAddAddressModal").click()
    }

  return (
    <Modal targetName={"addAddressModal"} modalSettings={"modal-xl"}>
        <div className="row p-0 p-lg-5">
        <div className="col-12 col-md-6 mb-5">
                <label htmlFor='name'>Name *</label>
                <input type="text" className='form-control' value={name} onChange={(e)=>setName(e.target.value)} placeholder="Name" />
            </div>
            <div className="col-12 col-md-6 mb-5">
                <label htmlFor='phone'>Phone Number *</label>
                <input type="number" name='phone' className='form-control' value={phoneNumber} onChange={(e)=>setPhoneNumber(e.target.value)} placeholder="Phone Number" />
            </div>
            <div className="col-12 col-md-6 mb-5">
                <label htmlFor='address'>Address *</label>
                <input type="text" name='address' className='form-control' value={address} onChange={(e)=>setAddress(e.target.value)} placeholder="Address" />
            </div>
            <div className="col-12 col-md-6 mb-5">
                <label htmlFor='pincode'>Pin Code *</label>
                <input type="number" name='pincode' className='form-control' value={pinCode} onChange={(e)=>setPinCode(e.target.value)} placeholder="Pin Code" />
            </div>
            <div className="col-12 col-md-6 mb-5">
                <label htmlFor='state'>State *</label>
                <input type="text" name='state' className='form-control' value={state} onChange={(e)=>setState(e.target.value)} placeholder="State" />
            </div>
            <div className="col-12 col-md-6 mb-5">
                <label htmlFor='country'>Country *</label>
                <input type="text" name='country' className='form-control' value={country} onChange={(e)=>setCountry(e.target.value)} placeholder="Country" />
            </div>
            {error && <p className='text-danger text-center w-100'>{error}</p>}
            <div className="col-12">
                <button className='btn btn-block btn-lg btn-outline-dark' onClick={handleSubmit}>{loading ? <div className="spinner-border loader-sizing" style={{height:"1.5rem", width:"1.5rem"}} role="status"><span className="sr-only"></span></div>:<>Add Address<i className="bi bi-plus" /></>}</button>
            </div>
        </div>
        <button className='d-none' data-dismiss="modal" id='closeAddAddressModal'>Close Modal</button>
    </Modal>
  )
}

export default AddAddress